export const SQDC_FIVE_W_TWO_H_KEYS = [
  "what",
  "why",
  "where",
  "when",
  "who",
  "how",
  "howMuch",
] as const;

export type SQDCFiveWTwoHKey = (typeof SQDC_FIVE_W_TWO_H_KEYS)[number];

export type SQDCFiveWTwoHValue = Record<SQDCFiveWTwoHKey, string>;

export const emptySQDCFiveWTwoHValue: SQDCFiveWTwoHValue = {
  what: "",
  why: "",
  where: "",
  when: "",
  who: "",
  how: "",
  howMuch: "",
};

export function isEmptySQDCFiveWTwoHValue(value: SQDCFiveWTwoHValue) {
  return SQDC_FIVE_W_TWO_H_KEYS.every((key) => value[key].trim() === "");
}

export function normalizeSQDCFiveWTwoHValue(value: unknown): SQDCFiveWTwoHValue | undefined {
  if (typeof value === "string") {
    if (value.trim() === "") return undefined;
    try {
      return normalizeSQDCFiveWTwoHValue(JSON.parse(value));
    } catch {
      return undefined;
    }
  }
  if (value == null || typeof value !== "object" || Array.isArray(value)) return undefined;
  const source = value as Partial<Record<SQDCFiveWTwoHKey, unknown>>;
  if (!SQDC_FIVE_W_TWO_H_KEYS.some((key) => key in source)) return undefined;
  return Object.fromEntries(
    SQDC_FIVE_W_TWO_H_KEYS.map((key) => [key, typeof source[key] === "string" ? source[key] : ""]),
  ) as SQDCFiveWTwoHValue;
}

export function formatSQDCFiveWTwoHValue(
  value: unknown,
  getLabel: (key: SQDCFiveWTwoHKey) => string,
) {
  const normalized = normalizeSQDCFiveWTwoHValue(value);
  if (normalized == null) return typeof value === "string" ? value : "";
  return SQDC_FIVE_W_TWO_H_KEYS.map((key) => [getLabel(key), normalized[key]] as const)
    .filter(([, entry]) => entry.trim() !== "")
    .map(([label, entry]) => `${label}: ${entry}`)
    .join(" · ");
}
